














































































































































































































import {
  mdiDelete,
  mdiFacebook,
  mdiTwitter,
  mdiDownload,
  mdiPlus,
  mdiImage,
  mdiYoutube,
  mdiVimeo,
  mdiDotsHorizontal,
  mdiRotateLeft,
  mdiRotateRight,
  mdiFlipHorizontal
} from "@mdi/js";
import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import { vxm } from "@/store";
import SlideshowControls from "@/components/slideshow/slideshow-controls.vue";
import AddBonusDialog from "@/components/slideshow/add-bonus-dialog.vue";
import BonusCard from "@/components/slideshow/bonus-card.vue";
import DeleteMediumDialog from "@/components/slideshow/delete-medium-dialog.vue";
import imagePlaceholder from "@/components/img-placeholder.vue";
import { mediumImageStyle as getMediumImageStyle } from "@/domain/event-medium";

@Component({
  components: {
    "slideshow-controls": SlideshowControls,
    "add-bonus-dialog": AddBonusDialog,
    "bonus-card": BonusCard,
    "delete-medium-dialog": DeleteMediumDialog,
    "key-press": () => import("vue-keypress"),
    "img-placeholder": imagePlaceholder
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        vxm.results.setMediumId(this.$route.params.medium);
        vxm.results.bindBonuses();
      }
    },

    mediumIndex(after, before) {
      if (after === -1 && before !== -1) {
        const nextMedium = vxm.results.media[before];

        if (nextMedium) {
          this.$router.replace(`/${vxm.results.eventId}/slideshow/${nextMedium.id}`);
        } else {
          this.$router.replace(`/${vxm.results.eventId}/slideshow`);
        }
      }
    }
  },

  destroyed() {
    vxm.results.unbindBonuses();
  }
})
export default class SlideshowSlide extends Vue {
  @Ref("asset") readonly asset!: Vue | HTMLVideoElement;
  @Ref("slideshowControls") readonly slideshowControls!: SlideshowControls;

  menuIcon = mdiDotsHorizontal;
  addBonusIcon = mdiPlus;
  deleteIcon = mdiDelete;
  downloadIcon = mdiDownload;
  facebookIcon = mdiFacebook;
  twitterIcon = mdiTwitter;
  imageIcon = mdiImage;
  youtubeIcon = mdiYoutube;
  vimeoIcon = mdiVimeo;
  rotateLeftIcon = mdiRotateLeft;
  rotateRightIcon = mdiRotateRight;
  mirrorIcon = mdiFlipHorizontal;
  addBonusDialog = false;
  deleteMediumDialog = false;
  slideshowTimeout?: any;
  transformSaveError = false;
  mediumImageStyle = getMediumImageStyle;

  get mediumIndex() {
    return vxm.results.media.findIndex(medium => medium.id === this.$route.params.medium);
  }

  get medium() {
    return vxm.results.media[this.mediumIndex];
  }

  get mediumIsSideways() {
    return !!this.medium && this.medium.rotation % 180 !== 0;
  }

  get team() {
    if (!this.medium) {
      return;
    }

    const teamId = this.medium.teamId;

    return vxm.results.teams.find(team => team.id === teamId);
  }

  get bonuses() {
    return vxm.results.bonuses;
  }

  get task() {
    if (!this.medium) {
      return;
    }

    const taskId = this.medium.taskId;

    return vxm.results.game.tasks.find(task => task.id === taskId);
  }

  get isInstructor() {
    return vxm.results.isInstructor;
  }

  get slideshow() {
    return vxm.results.slideshow;
  }

  get url() {
    return `https://${window.location.hostname}${this.$route.fullPath}`;
  }

  onImageLoad() {
    this.assetLoaded(6000);
  }

  assetLoaded(timeout: number) {
    if (!this.slideshow) {
      return;
    }

    this.slideshowTimeout = setTimeout(() => {
      if (!this.slideshow) {
        return;
      }

      if (this.slideshowControls.nextMedium) {
        this.$router.push(`/${vxm.results.eventId}/slideshow/${this.slideshowControls.nextMedium.id}`);
      } else {
        this.$router.push(`/${vxm.results.eventId}/slideshow`);
      }
    }, timeout);
  }

  keyPress({ event }: { event: KeyboardEvent }) {
    if (this.addBonusDialog || this.deleteMediumDialog) {
      return;
    }

    if (event.keyCode === 32) {
      if (this.asset instanceof HTMLVideoElement && document.activeElement !== this.asset) {
        if (this.asset.currentTime > 0 && !this.asset.paused && !this.asset.ended && this.asset.readyState > 2) {
          this.asset.pause();
        } else {
          this.asset.play();
        }
      } else {
        this.slideshowControls.toggleSlideshow();
      }
    }
  }

  async rotateMedium(rotationChange: -90 | 90) {
    if (!this.medium) {
      return;
    }

    try {
      await vxm.results.updateMediumTransform({
        rotation: this.medium.rotation + rotationChange,
        mirrored: this.medium.mirrored
      });
    } catch (_err) {
      this.transformSaveError = true;
    }
  }

  async mirrorMedium() {
    if (!this.medium) {
      return;
    }

    try {
      await vxm.results.updateMediumTransform({
        rotation: this.medium.rotation,
        mirrored: !this.medium.mirrored
      });
    } catch (_err) {
      this.transformSaveError = true;
    }
  }

  async download() {
    if (!this.medium) {
      return;
    }

    const res = await fetch(this.medium.original);
    const blob = await res.blob();
    const extensionMatch = this.medium.original.replace(/\?.*?$/, "").match(/^.*?\.(\w+)$/);
    const extension = extensionMatch ? extensionMatch[1] : "jpg";
    const filename = `${this.team ? this.team.name : this.medium.id} (${this.task ? this.task.id : this.medium.id}).${extension}`;

    const { saveAs } = await import("file-saver");
    saveAs(blob, filename);
  }

  @Watch("medium")
  mediumChange() {
    if (this.slideshowTimeout) {
      clearTimeout(this.slideshowTimeout);
    }
  }

  @Watch("slideshow")
  slideshowChange() {
    if (this.slideshow) {
      this.assetLoaded(0);
    }
  }
}
